<template>
  <div class="flex flex-column gap-2">
    <label
      v-for="type in types"
      :key="type"
      class="flex align-items-center justify-content-between gap-3 cursor-pointer"
    >
      <span class="flex align-items-center gap-2">
        <Checkbox
          :model-value="selectedTypes.includes(type)"
          binary
          @update:model-value="$emit('toggle', type, $event)"
        />
        {{ t(`modules.commandMenu.v2.type.${type}`) }}
      </span>
      <span v-if="counts?.has(type)" class="text-color-secondary text-sm">
        {{ counts.get(type) }}
      </span>
    </label>
  </div>
</template>

<script setup lang="ts">
import Checkbox from "primevue/checkbox";
import { useAppTranslate } from "@/language/staticTranslations";
import type { GlobalSearchUIType } from "../helper/GlobalSearchTypes";

defineProps<{
  types: GlobalSearchUIType[];
  selectedTypes: GlobalSearchUIType[];
  counts?: Map<GlobalSearchUIType, number>;
}>();

defineEmits<{
  toggle: [type: GlobalSearchUIType, selected: boolean];
}>();
const { t } = useAppTranslate();
</script>
